import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FcdlModalModule, FooterModule, LinkModule } from '@fmr-ap001330/fc-modern-angular-modules';
import { FooterContainerComponent } from './footer/footer-container.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderContainerComponent } from './header/header-container.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
    declarations: [
        FooterContainerComponent,
        FooterComponent,
        HeaderComponent,
        HeaderContainerComponent,
    ],
    imports: [CommonModule, ReactiveFormsModule, FooterModule, FcdlModalModule, LinkModule],
    exports: [
        FooterContainerComponent,
        FooterComponent,
        HeaderComponent,
        HeaderContainerComponent,
    ],
})
export class LayoutModule {}
